import { StateCombobox } from '@/components/shared';
import { formatarCPF, apenasDigitos, cpfValido } from '../../../utils/masks';
import type { RespostasEtapa1Candidato } from '../../../models';

interface EtapaDadosPessoaisProps {
  respostas: RespostasEtapa1Candidato;
  onChange: (campo: keyof RespostasEtapa1Candidato, valor: string) => void;
}

export default function EtapaDadosPessoais({ respostas, onChange }: EtapaDadosPessoaisProps) {
  return (
    <>
      <h2 className="mb-6 text-2xl font-bold text-gray-800">Dados Pessoais</h2>
      <div className="space-y-5">
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">Nome completo *</label>
          <input
            type="text"
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            value={respostas.nomeCompleto ?? ''}
            onChange={(e) => onChange('nomeCompleto', e.target.value)}
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">Data de nascimento *</label>
          <input
            type="date"
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            value={respostas.dataNascimento ?? ''}
            onChange={(e) => onChange('dataNascimento', e.target.value)}
          />
        </div>
        {/* Órgão emissor, UF e data de emissão ficam na Etapa 2 (decisão do RH: na Etapa 1
            basta o número). */}
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">RG *</label>
          <input
            type="text"
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            value={respostas.rg ?? ''}
            onChange={(e) => onChange('rg', e.target.value)}
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">CPF *</label>
          <input
            type="text"
            inputMode="numeric"
            placeholder="000.000.000-00"
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            value={formatarCPF(respostas.cpf ?? '')}
            onChange={(e) => onChange('cpf', apenasDigitos(e.target.value))}
          />
          {apenasDigitos(respostas.cpf ?? '').length === 11 && !cpfValido(respostas.cpf) && (
            <p className="mt-1 text-sm text-red-600">CPF inválido — confira os números.</p>
          )}
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="mb-1 block text-sm font-semibold text-gray-700">Cidade de nascimento *</label>
            <input
              type="text"
              className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
              value={respostas.cidadeNascimento ?? ''}
              onChange={(e) => onChange('cidadeNascimento', e.target.value)}
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-semibold text-gray-700">Estado (UF) de nascimento *</label>
            <StateCombobox
              selectedValue={respostas.ufNascimento ?? null}
              onChange={(valor) => onChange('ufNascimento', valor ?? '')}
            />
          </div>
        </div>
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">
            Cidade e Estado de residência atual *
          </label>
          <input
            type="text"
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            value={respostas.cidadeEstadoResidencia ?? ''}
            onChange={(e) => onChange('cidadeEstadoResidencia', e.target.value)}
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">Nome completo da mãe *</label>
          <input
            type="text"
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            value={respostas.nomeMae ?? ''}
            onChange={(e) => onChange('nomeMae', e.target.value)}
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">Nome completo do pai *</label>
          <input
            type="text"
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            value={respostas.nomePai ?? ''}
            onChange={(e) => onChange('nomePai', e.target.value)}
          />
        </div>
      </div>
    </>
  );
}
